// The Spanish half of ./terms.ts (rc.12 (b)). The ONE Spanish track that stays
// in the entry (i18n/index.ts imports it): the Terms sentence follows the
// SERVED Terms' language whatever the page's (TermsAgreement, rule d; Legal).
// The English shape is a type-only import.
import type { en } from "../terms";

export const es: Partial<Record<keyof typeof en, string>> = {
  "terms.agree": "Tengo 18 años o más y acepto los [Términos de servicio] de Lura.",
  "terms.privacy": "Consulta nuestra [Política de privacidad].",
  "link.newTab": " (se abre en una pestaña nueva)",
  "terms.changed.body": "Léelos y vuelve a aceptarlos.",
  "terms.changed.title": "Los términos cambiaron.",
  "terms.reload": "Intentar de nuevo",
  "terms.unavailable.account": "No pudimos cargar los términos.",
  "terms.unavailable.booking": "No pudimos cargar los términos.",
};
